import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
  footnote?: string;
};
export function Countdown({
  tone = 'light',
  footnote
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const isDark = tone === 'dark';
  const labelColor = isDark ? 'text-white/80' : 'text-navy2';
  const boxColor = isDark ? 'bg-white text-navy' : 'bg-navy text-white';
  const units = [{
    value: hours,
    label: 'HRS'
  }, {
    value: minutes,
    label: 'MIN'
  }, {
    value: seconds,
    label: 'SEC'
  }];
  return <div className="flex flex-col items-center" data-id="element-60" data-mp="324zxjtzgtuw5">
      <p className={`flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.18em] ${labelColor}`} data-id="element-61" data-mp="372t1shh7kets">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-62" data-mp="10dej9n0l2ztn" />
        This special offer ends in:
      </p>

      <div className="mt-3 flex items-center gap-2" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-63" data-mp="15a504ck7pzg4">
        {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-64" data-mp="t091ku5bp5nm" data-mpi={index}>
            <div className="flex flex-col items-center" data-id="element-65" data-mp="17py9r9bu29xe">
              <div className={`flex h-[62px] w-[62px] items-center justify-center rounded-xl text-[28px] font-black tabular-nums shadow-md sm:h-[72px] sm:w-[72px] sm:text-[34px] ${boxColor}`} data-id="element-66" data-mp="12rwoqiuuk0ja">
                {unit.value}
              </div>
              <span className={`mt-1.5 text-[10px] font-bold uppercase tracking-[0.14em] ${labelColor}`} data-id="element-67" data-mp="a52ba5wg61fb">
                {unit.label}
              </span>
            </div>
            {index < units.length - 1 ? <span className={`-mt-5 text-2xl font-black ${isDark ? 'text-white/50' : 'text-navy/40'}`} aria-hidden="true" data-id="element-68" data-mp="1zhmfve40q07s">
                :
              </span> : null}
          </React.Fragment>)}
      </div>

      {footnote ? <p className={`mt-3 text-center text-xs font-semibold ${isDark ? 'text-white/70' : 'text-navy2/70'}`} data-id="element-69" data-mp="x36itvt5vv0y">
          {footnote}
        </p> : null}
    </div>;
}